export default "<p>month-picker works!</p>\r\n"